import { render, staticRenderFns } from "./LoginSimple.vue?vue&type=template&id=b7bc2396&scoped=true"
import script from "./LoginSimple.vue?vue&type=script&lang=js"
export * from "./LoginSimple.vue?vue&type=script&lang=js"
import style0 from "./LoginSimple.vue?vue&type=style&index=0&id=b7bc2396&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7bc2396",
  null
  
)

export default component.exports